var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCube6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.373,
    height: 66.632,
    viewBox: "0 0 37.373 66.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_183995",
    "data-name": "\\uADF8\\uB8F9 183995",
    transform: "translate(-262.763 390.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182048",
    "data-name": "\\uADF8\\uB8F9 182048",
    transform: "translate(272.756 -390.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182041",
    "data-name": "\\uADF8\\uB8F9 182041",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182039",
    "data-name": "\\uADF8\\uB8F9 182039",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130590",
    "data-name": "\\uD328\\uC2A4 130590",
    d: "M642.965,534.944l14.021,7.812V526.291l-14.021-7.812Z",
    transform: "translate(-642.965 -518.479)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182040",
    "data-name": "\\uADF8\\uB8F9 182040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130591",
    "data-name": "\\uD328\\uC2A4 130591",
    d: "M656.625,542.632a.246.246,0,0,1-.116-.03l-14.021-7.812a.237.237,0,0,1-.122-.208V518.118a.238.238,0,0,1,.354-.208l14.021,7.812a.238.238,0,0,1,.123.209v16.464a.239.239,0,0,1-.117.206A.248.248,0,0,1,656.625,542.632Zm-13.783-8.19,13.544,7.546V526.069l-13.544-7.546Z",
    transform: "translate(-642.365 -517.879)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182044",
    "data-name": "\\uADF8\\uB8F9 182044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182042",
    "data-name": "\\uADF8\\uB8F9 182042",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130592",
    "data-name": "\\uD328\\uC2A4 130592",
    d: "M642.965,507.642l14.1,7.826,12.8-7.173-14.1-7.827Z",
    transform: "translate(-642.965 -500.468)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182043",
    "data-name": "\\uADF8\\uB8F9 182043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130593",
    "data-name": "\\uD328\\uC2A4 130593",
    d: "M656.706,515.345a.23.23,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.24.24,0,0,1,.232,0l14.1,7.827a.239.239,0,0,1,0,.416l-12.8,7.174A.248.248,0,0,1,656.706,515.345Zm-13.615-8.065,13.614,7.554,12.311-6.9L655.4,500.379Z",
    transform: "translate(-642.365 -499.869)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182047",
    "data-name": "\\uADF8\\uB8F9 182047",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182045",
    "data-name": "\\uADF8\\uB8F9 182045",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130594",
    "data-name": "\\uD328\\uC2A4 130594",
    d: "M691.537,537.156l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-678.916 -520.17)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182046",
    "data-name": "\\uADF8\\uB8F9 182046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130595",
    "data-name": "\\uD328\\uC2A4 130595",
    d: "M678.554,543.767a.24.24,0,0,1-.239-.239V526.9a.237.237,0,0,1,.122-.208l12.621-7.091a.235.235,0,0,1,.237,0,.24.24,0,0,1,.118.206v16.986a.237.237,0,0,1-.126.211l-12.621,6.734A.241.241,0,0,1,678.554,543.767Zm.238-16.729v16.093l12.145-6.48V520.214Zm12.383,9.756h0Z",
    transform: "translate(-678.315 -519.568)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182185",
    "data-name": "\\uADF8\\uB8F9 182185",
    transform: "translate(262.763 -355.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182178",
    "data-name": "\\uADF8\\uB8F9 182178",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182176",
    "data-name": "\\uADF8\\uB8F9 182176",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130674",
    "data-name": "\\uD328\\uC2A4 130674",
    d: "M617.81,622.06l14.021,7.812V613.406l-14.021-7.812Z",
    transform: "translate(-617.81 -605.595)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182177",
    "data-name": "\\uADF8\\uB8F9 182177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130675",
    "data-name": "\\uD328\\uC2A4 130675",
    d: "M631.47,629.75a.238.238,0,0,1-.116-.031l-14.021-7.812a.236.236,0,0,1-.122-.208V605.234a.237.237,0,0,1,.117-.205.24.24,0,0,1,.237,0l14.021,7.812a.237.237,0,0,1,.122.208v16.465a.24.24,0,0,1-.238.239Zm-13.783-8.191,13.545,7.546V613.186l-13.545-7.546Z",
    transform: "translate(-617.21 -604.996)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182181",
    "data-name": "\\uADF8\\uB8F9 182181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182179",
    "data-name": "\\uADF8\\uB8F9 182179",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130676",
    "data-name": "\\uD328\\uC2A4 130676",
    d: "M617.81,594.758l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-617.81 -587.585)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182180",
    "data-name": "\\uADF8\\uB8F9 182180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130677",
    "data-name": "\\uD328\\uC2A4 130677",
    d: "M631.551,602.461a.244.244,0,0,1-.116-.03l-14.1-7.827a.238.238,0,0,1,0-.416l12.8-7.174a.238.238,0,0,1,.233,0l14.1,7.826a.239.239,0,0,1,0,.417l-12.8,7.173A.236.236,0,0,1,631.551,602.461ZM617.937,594.4l13.614,7.555,12.311-6.9L630.248,587.5Z",
    transform: "translate(-617.21 -586.984)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182184",
    "data-name": "\\uADF8\\uB8F9 182184",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182182",
    "data-name": "\\uADF8\\uB8F9 182182",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130678",
    "data-name": "\\uD328\\uC2A4 130678",
    d: "M666.382,624.272l-12.622,6.734v-16.63l12.622-7.091Z",
    transform: "translate(-653.761 -607.284)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182183",
    "data-name": "\\uADF8\\uB8F9 182183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130679",
    "data-name": "\\uD328\\uC2A4 130679",
    d: "M653.4,630.882a.237.237,0,0,1-.239-.238v-16.63a.239.239,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.355.207V623.91a.238.238,0,0,1-.126.211l-12.621,6.733A.24.24,0,0,1,653.4,630.882Zm.238-16.729v16.094l12.145-6.48V607.33Zm12.383,9.757h0Z",
    transform: "translate(-653.161 -606.684)",
    fill: "#111"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCube6);
export default __webpack_public_path__ + "static/media/information_cube6.fee6233918641da3839b6547704711d2.svg";
export { ForwardRef as ReactComponent };